import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useBookingsPaginationStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: tokens.spacingVerticalL,
    marginBottom: '3rem',
  },
  nav: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    justifyContent: 'center',
    color: tokens.colorNeutralForeground1,
  },
  pageList: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    justifyContent: 'center',
  },
  navButton: {
    minWidth: '2rem',
    height: '2rem',
    color: tokens.colorNeutralForeground3,
    ':hover': {
      color: tokens.colorNeutralForeground1,
      backgroundColor: 'transparent',
    },
    ':disabled': {
      color: tokens.colorNeutralForegroundDisabled,
      backgroundColor: 'transparent',
    },
  },
  pageButton: {
    minWidth: '2rem',
    height: '2rem',
    color: tokens.colorNeutralForeground1,
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightRegular + ' !important',
    backgroundColor: 'transparent',
    ...shorthands.borderRadius(tokens.borderRadiusNone),
    ...shorthands.padding(0, tokens.spacingHorizontalXS),
    position: 'relative',
    ':hover': {
      backgroundColor: 'transparent',
      color: tokens.colorNeutralForeground1,
    },
  },
  activePage: {
    fontWeight: tokens.fontWeightSemibold,
    ':hover': {
      backgroundColor: 'transparent',
    },
    '::after': {
      content: '""',
      position: 'absolute',
      left: tokens.spacingHorizontalXS,
      right: tokens.spacingHorizontalXS,
      bottom: 0,
      height: '2px',
      backgroundColor: tokens.colorBrandStroke1,
      ...shorthands.borderRadius(tokens.borderRadiusSmall),
    },
  },
});
